/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAction } from 'deox';
import {
  CATALOG_CURRENT_STEP,
  CATALOG_GET_LIST_FAILURE,
  CATALOG_GET_LIST_REQUEST,
  CATALOG_GET_LIST_SUCCESS,
  CATALOG_RESET,
  CATALOG_SELECT_CAR_TYPE,
  CATALOG_SELECT_MARK,
  CATALOG_SET_ALL_MARKS,
  CATALOG_SET_GROUPS,
  CATALOG_SET_MARK,
  CATALOG_SET_MODEL,
  CATALOG_SET_MODIFICATION,
  CATALOG_SET_PARENT_GROUPS,
  CatalogParamsProps,
  GET_GROUPS_FAILURE,
  GET_GROUPS_REQUEST,
  GET_GROUPS_SUCCESS,
  GET_MODELS_FAILURE,
  GET_MODELS_REQUEST,
  GET_MODELS_SUCCESS,
  GET_MODIFICATION_FAILURE,
  GET_MODIFICATION_REQUEST,
  GET_MODIFICATION_SUCCESS,
  GET_PARTS_FAILURE,
  GET_PARTS_REQUEST,
  GET_PARTS_SUCCESS,
  GET_SCHEME_FAILURE,
  GET_SCHEME_REQUEST,
  GET_SCHEME_SUCCESS,
  GET_SUBGROUPS_FAILURE,
  GET_SUBGROUPS_REQUEST,
  GET_SUBGROUPS_SUCCESS,
  MarkWithBrandProps,
  SEARCH_BY_VIN_FAILURE,
  SEARCH_BY_VIN_REQUEST,
  SEARCH_BY_VIN_SUCCESS,
} from './types';
import {
  GroupDTO,
  ModelDTO,
  ModificationsResponseDTO,
  PartsModelDTO,
  SearchByVinDTO,
  TypeDTO,
} from '../../types';

// ======= GET SEARCH_BY_VIN =======

export const searchByVINAction = {
  request: createAction(SEARCH_BY_VIN_REQUEST, resolve => (payload: any) => resolve(payload)),
  success: createAction(
    SEARCH_BY_VIN_SUCCESS,
    resolve => (payload: SearchByVinDTO) => resolve(payload),
  ),
  failure: createAction(SEARCH_BY_VIN_FAILURE, resolve => (error: string) => resolve(error)),
};

// ======= GET CATALOGS =======

export const getCatalogAction = {
  request: createAction(CATALOG_GET_LIST_REQUEST, resolve => () => resolve()),
  success: createAction(
    CATALOG_GET_LIST_SUCCESS,
    resolve => (payload: TypeDTO[]) => resolve(payload),
  ),
  failure: createAction(CATALOG_GET_LIST_FAILURE, resolve => (error: string) => resolve(error)),
};

// ======= GET MODELS =======
export const getModelsAction = {
  request: createAction(
    GET_MODELS_REQUEST,
    resolve => (payload: Partial<CatalogParamsProps>) => resolve(payload),
  ),
  success: createAction(GET_MODELS_SUCCESS, resolve => (payload: ModelDTO[]) => resolve(payload)),
  failure: createAction(GET_MODELS_FAILURE, resolve => (error: string) => resolve(error)),
};

// ======= GET MODIFICATIONS =======
export const getModificationAction = {
  request: createAction(
    GET_MODIFICATION_REQUEST,
    resolve => (payload?: Partial<CatalogParamsProps>) => resolve(payload),
  ),
  success: createAction(
    GET_MODIFICATION_SUCCESS,
    resolve => (payload: ModificationsResponseDTO) => resolve(payload),
  ),
  failure: createAction(GET_MODIFICATION_FAILURE, resolve => (error: string) => resolve(error)),
};

// ======= GET GROUPS =======
export const getGroupsAction = {
  request: createAction(
    GET_GROUPS_REQUEST,
    resolve => (payload: Partial<CatalogParamsProps>) => resolve(payload),
  ),
  success: createAction(GET_GROUPS_SUCCESS, resolve => (payload: GroupDTO[]) => resolve(payload)),
  failure: createAction(GET_GROUPS_FAILURE, resolve => (error: string) => resolve(error)),
};

// ======= GET SUBGROUPS =======
export const getSubGroupsAction = {
  request: createAction(
    GET_SUBGROUPS_REQUEST,
    resolve => (payload: Partial<CatalogParamsProps>) => resolve(payload),
  ),
  success: createAction(
    GET_SUBGROUPS_SUCCESS,
    resolve => (payload: GroupDTO[]) => resolve(payload),
  ),
  failure: createAction(GET_SUBGROUPS_FAILURE, resolve => (error: string) => resolve(error)),
};

// ======= GET PARTS =======
export const getPartsAction = {
  request: createAction(
    GET_PARTS_REQUEST,
    resolve => (payload: Partial<CatalogParamsProps>) => resolve(payload),
  ),
  success: createAction(GET_PARTS_SUCCESS, resolve => (payload: PartsModelDTO) => resolve(payload)),
  failure: createAction(GET_PARTS_FAILURE, resolve => (error: string) => resolve(error)),
};

// ======= GET SCHEME =======
export const getScheme = {
  request: createAction(GET_SCHEME_REQUEST),
  success: createAction(
    GET_SCHEME_SUCCESS,
    resolve => (payload: string | null) => resolve(payload),
  ),
  failure: createAction(GET_SCHEME_FAILURE, resolve => (error: string) => resolve(error)),
};

// ======= SET & GET =======

export const setAllMarksAction = createAction(
  CATALOG_SET_ALL_MARKS,
  resolve => (payload: MarkWithBrandProps[]) => resolve(payload),
);

export const resetCatalogData = createAction(CATALOG_RESET);

export const setCarTypeAction = createAction(
  CATALOG_SELECT_CAR_TYPE,
  resolve => (payload: string) => resolve(payload),
);

export const setCarMarkAction = createAction(
  CATALOG_SET_MARK,
  resolve => (payload: string) => resolve(payload),
);

export const setCarModelAction = createAction(
  CATALOG_SET_MODEL,
  resolve => (payload: string) => resolve(payload),
);

export const setCarModificationAction = createAction(
  CATALOG_SET_MODIFICATION,
  resolve => (payload: string) => resolve(payload),
);

export const setCarGroupsAction = createAction(
  CATALOG_SET_GROUPS,
  resolve => (payload: string) => resolve(payload),
);

export const setCarParentGroupAction = createAction(
  CATALOG_SET_PARENT_GROUPS,
  resolve => (payload: string) => resolve(payload),
);

export const setCatalogStepAction = createAction(
  CATALOG_CURRENT_STEP,
  resolve => (payload: number) => resolve(payload),
);

export const setSelectedMarkAction = createAction(
  CATALOG_SELECT_MARK,
  resolve => (payload: MarkWithBrandProps) => resolve(payload),
);
